import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import axiosInstance, { getApiBaseUrl } from '../src/components/services/axiosInstance.js';

export const fetchTranslations = async (lang) => {
  try {
    const response = await axiosInstance.get(`/locales/${lang}/translation.json`);
    return response.data;
  } catch (error) {
    console.error('Error fetching translations:', error);
    return {};
  }
};

const initializeI18n = async () => {
  const defaultLang = 'en-GB';
  const resources = {};

  try {
    const languages = ['de-CH', 'fr-CH', 'en-GB', 'pl-PL', 'fr-FR', 'de-DE'];

    for (const lang of languages) {
      const data = await fetchTranslations(lang);
      resources[lang] = { translation: data };
    }

    const savedLanguage = localStorage.getItem('language');
    const languageToSet = savedLanguage || defaultLang;

    i18n
      .use(initReactI18next)
      .init({
        resources,
        lng: languageToSet,
        fallbackLng: defaultLang,
        interpolation: { escapeValue: false },
      });

    i18n.on('languageChanged', (lng) => {
      localStorage.setItem('language', lng);
    });

  } catch (error) {
    console.error('Error initializing i18n:', error);
  }
};

initializeI18n();

export default i18n;
